module.exports = __webpack_public_path__ + "static/logo_remote-acf4cf2c200cde8437986cbbfb473a7f.svg";